import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, computed } from 'vue';
import { useTheme } from 'vuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSwitcher',
  props: {
    asListItem: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props;

const localStorageTheme = localStorage.getItem('theme') as string;
const theme = useTheme();

const themeIcon = computed(() => {
    const themeIsDark = theme.global.current.value.dark;
    if (!themeIsDark) {
        return 'mdi-white-balance-sunny';
    }
    return 'mdi-moon-waxing-crescent';
})

function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark';
    localStorage.setItem('theme', theme.global.name.value);
}

onMounted(() => {
    if (localStorageTheme) {
        theme.global.name.value = localStorageTheme;
    }
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (__props.asListItem)
    ? (_openBlock(), _createBlock(_component_v_list_item, {
        key: 0,
        onClick: toggleTheme,
        "prepend-icon": themeIcon.value,
        title: "Tema"
      }, null, 8, ["prepend-icon"]))
    : (_openBlock(), _createBlock(_component_v_btn, {
        key: 1,
        density: "compact",
        size: "medium",
        onClick: toggleTheme,
        icon: themeIcon.value
      }, null, 8, ["icon"]))
}
}

})